module.exports = __webpack_public_path__ + "img/img2.c5a5f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img2.png
// module id = 242
// module chunks = 0